export const meta = { id: 'O07', slug: 'criar-metodologia', title: 'Como criar uma Metodologia', description: 'Crie ou duplique uma metodologia e organize sua estrutura de competências.', profile: 'owner', category: 'metodologia', type: 'task', status: 'published', order: 370, keywords: ['criar metodologia','duplicar metodologia','competências'], previous: 'O06', next: 'O08', related: ['O08','O09','O10'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como criar uma Metodologia

Uma metodologia define a estrutura que será usada para interpretar competências e desenvolvimento.

<HelpImage pendingId="O07.2" alt="Detalhe de uma metodologia" />

<Steps>
  <Step title="Abra Gestão e Metodologia">Acesse a área de metodologias.</Step>
  <Step title="Crie ou duplique">Use uma nova metodologia ou duplique uma base existente quando essa for a opção disponível.</Step>
  <Step title="Defina as competências">Inclua as competências que farão parte da estrutura.</Step>
  <Step title="Configure níveis e descritores">Dê significado comportamental aos níveis.</Step>
  <Step title="Revise antes de usar">Confirme coerência e clareza antes de utilizar a metodologia no Diagnóstico.</Step>
</Steps>

<Callout type="important">Na versão atual, a metodologia oficial é alterada pelo Owner. A duplicação permite preservar uma base e ajustar uma nova versão.</Callout>
